import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SalesContext } from 'src/Context/SalesContext';
import './AdditionCard.css';

const NewAdditionalCard = (props) => {

  const context = useContext(SalesContext);

  const {
    setAdditionalServices,
    setAdditionalVas,
    setLteReviewData,
    additionalVas,
    setSelectedAdditionalServices,
    setUnselectedContractCover
  } = context;
  let handleOnSelect = () => { };

  if (props.vasCategory === 'superWifi' || props.vasCategory === 'contractCover' || props.vasCategory === 'voiceLine') {

    handleOnSelect = function () {
      let addVas = context.additionalVas;
      let removed = false;

      if (addVas) {
        for (let index = 0; index < addVas.length; index++) {
          if (addVas[index].category === props.vasCategory) {
            if (props.offerId === addVas[index].offerId)
              removed = true;

            addVas.splice(index, 1);

            if (props.vasCategory == 'contractCover')
              setUnselectedContractCover(true);

            setSelectedAdditionalServices({ key: props.vasCategory, value: false });
          }
        }
      }

      if (removed == false) {

        if (props.vasCategory == 'contractCover')
          setUnselectedContractCover(false);

        if (!addVas)
          addVas = [];

        addVas.push({
          'category': props.vasCategory,
          'offerId': props.offerId,
          'price': props.price,
          'contractTerm': props.contractTerm,
          'acronym': props.acronym,
          'displayName': props.displayName,
          'priceDescription': props.priceDescription,
          'discount': props.discount ? props.discount : '',
          'imgUrl': props.imgUrl
        });

        setSelectedAdditionalServices({ key: props.vasCategory, value: true });
      }

      setAdditionalVas(addVas)
    }

    if (props.vasCategory === 'superWifi')
      return (

        <div className={ props.isSelected ? 'selected-card' : 'superwifi-container ' }>
          <div className='additional-service-img'>
            <img src={ props.imgUrl } alt={ props.vasCategory } />
          </div>
          <span className='additional-service-price'>
            <b className='additiona-service-price-tags'>{ props?.price }</b> { parseInt(props.contractTerm) ? 'PM x ' + props.contractTerm : 'Once-off' }
          </span>
          <button onClick={ () => handleOnSelect()} className={props.isSelected ? 'additional-service-selected-button' : 'additional-service-button' }>
            { props.isSelected ? 'Remove from contract' : 'Add to contract' }
          </button>

          { props.discount &&
              <p className='price-discount'>
                {`First ${props.discount.replace(/\(.*$/, '').toLowerCase()}!`}
              </p>
          }


        </div>
      );

    if (props.vasCategory === 'contractCover')
      return (

        <div className={ props.isSelected ? 'selected-card' : 'contract-cover-plus-container' }>
          <div className='contract-cover-plus-main'>
            <div className='contract-cover-plus-logo-main-container'>
              <img className='contract-cover-plus-logo-container' src={ props.imgUrl } alt="VodaSure Logo" />
            </div>
            <span className='contract-cover-plus-text'>Contract Cover Plus</span>
            <div className='contract-cover-prize-container'>
              <span className='contract-cover-plus-prize'>+ {props?.price} PM { parseInt(props.contractTerm) ? ' x ' + props.contractTerm : '' }</span>
            </div>
            <button onClick={ () => handleOnSelect() } className={ props.isSelected ? 'additional-service-selected-button' : 'additional-service-button' }>{ props.isSelected ? 'Remove from contract' : 'Add to contract' }</button>
          </div>
        </div>
      );

    if (props.vasCategory === 'voiceLine')

      return (
        <div className={ props.isSelected ? 'selected-voip ' : 'voip-container' }>
          <div className='contract-cover-plus-main'>
            <div className='voip-logo-main-container'>
              <img className='voip-logo' src={ props.imgUrl } alt="Voice Line" />
            </div>
            <div className='voip-price-container'>
              <span className='voip-price'>{ props.priceDescription }</span>
            </div>
            <button onClick={ props.updateAdditionalServices } className={ props.isSelected ? 'additional-service-selected-button' : 'additional-service-button' }>{ props.isSelected ? 'Remove from contract' : 'I am interested' }</button>
          </div>
        </div>
      );

  } else if (props.serviceKey === 'lte') {

    handleOnSelect = function () {

      if (props.category) {
        if (additionalVas?.parameterId == props?.parameterId) {
          setLteReviewData(null);
          setAdditionalServices(null);
        } else {
          setAdditionalServices({
            key: props.category,
            offerId: props.offerId,
            actionId: props.actionId,
            parameterId: props.parameterId
          });

          setLteReviewData({
            displayName: props.displayName,
            promotion: props.promotion,
            size: props.size,
            price: props.price,
            lteImageUrl: props.lteImageUrl
          });
        }
      }
    }
  }
}

NewAdditionalCard.propTypes = {
  size: PropTypes.string,
  price: PropTypes.string,
  handleOnClick: PropTypes.func,
  category: PropTypes.string,
  offerId: PropTypes.string,
  actionId: PropTypes.string,
  parameterId: PropTypes.string,
  displayName: PropTypes.string,
  promotion: PropTypes.string,
  lteImageUrl: PropTypes.string,
  priceValue: PropTypes.number,
  parameterValue: PropTypes.string,
  vasCategory: PropTypes.string,
  isSelected: PropTypes.bool,
  contractTerm: PropTypes.string,
  acronym: PropTypes.string,
  priceDescription: PropTypes.string,
  discount: PropTypes.string,
  imgUrl: PropTypes.string,
  updateAdditionalServices: PropTypes.func,
  serviceKey: PropTypes.string
}

export default NewAdditionalCard;